import axios from 'axios'

export const HTTP_WITHOUT_HEADER = () => {
  const origin = window.location.origin
  return axios.create({
    baseURL: origin + '/'
  })
}

export const HTTP = (token) => {
  const origin = window.location.origin
  return axios.create({
    baseURL: origin + '/',
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
}

export const HTTP_FIREBASE_SHORTLINK = () => {
  return axios.create({
    baseURL: 'https://firebasedynamiclinks.googleapis.com/',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils.js